import { useEffect } from 'react'

const ICON_REL_SELECTOR = "link[rel*='icon']"

const ensureFaviconLink = (): { link: HTMLLinkElement; created: boolean } => {
    const existingLink = document.head.querySelector<HTMLLinkElement>(ICON_REL_SELECTOR)

    if (existingLink) {
        return { link: existingLink, created: false }
    }

    const linkElement = document.createElement('link')
    linkElement.rel = 'icon'
    document.head.appendChild(linkElement)

    return { link: linkElement, created: true }
}

/**
 * Updates the document favicon. Ensures the link element lives in <head> as required by browsers.
 * When the component unmounts we restore the previous favicon, if one existed.
 */
export const useFavicon = (href: string | null | undefined): void => {
    useEffect(() => {
        if (!href) {
            return
        }

        const { link: linkElement, created } = ensureFaviconLink()
        const previousHref = linkElement.href
        const previousType = linkElement.type

        linkElement.type = 'image/svg+xml'
        linkElement.href = href

        return () => {
            if (created && linkElement.parentElement) {
                linkElement.parentElement.removeChild(linkElement)
                return
            }

            if (previousHref) {
                linkElement.href = previousHref
            }

            if (previousType) {
                linkElement.type = previousType
            }
        }
    }, [href])
}
